import { observer } from 'mobx-react-lite'
import { TextFieldPlaceholder } from 'shared/ui/TextField'
import { EnrollmentPreview } from 'widgets/ContactEnrollment/ui/EnrollmentList'
import type { EnrollmentFilters } from 'widgets/ContactEnrollment'
import styles from './styles.module.scss'

type ITriggerStep3Props = {
  enrollmentFilters: EnrollmentFilters
  onEdit: () => void
}

export const TriggerStep3 = observer(({ enrollmentFilters, onEdit }: ITriggerStep3Props) => {
  return (
    <div className={styles.selectWrap}>
      <TextFieldPlaceholder
        className={styles.enrollField}
        variant='stroke'
        size='small'
        onClick={onEdit}
        placeholder={
          <div className={styles.preview}>
            {enrollmentFilters.allSize ? (
              <EnrollmentPreview filters={enrollmentFilters} />
            ) : (
              'Select criteria'
            )}
          </div>
        }
      />
    </div>
  )
})
